<template>
    <div class="gap-md flex h-40 flex-col items-center justify-center">
        <i v-if="icon !== false" :class="icon || 'i-no-results'" class="size-xl" />
        <div class="gap-xs flex flex-col items-center text-center">
            <h2>{{ title }}</h2>
            <p class="text-primary">{{ message }}</p>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    icon?: string | false;
    title: string;
    message: string;
}>();
</script>
